export default function PRAProcessesController(

) {
  const vm = this;

  _activate();

  /** *************************************************
   * Private Functions
   */

  function _activate() {
    _initIT();
  }

  function _initIT() {
    vm.assessment.informationTechnologyProcess = vm.assessment.assessmentProcesses.find(process => process.isManaged);
    vm.assessment.nonITProcesses = vm.assessment.assessmentProcesses.filter(process => !process.isManaged);
  }
}

PRAProcessesController.$inject = [

];
